import { View } from 'react-native';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { isPatientApp } from '@/config/constants';
import { Links } from '@/config/links';
import { styles } from './styles';

function FirstConfirmAccountDelete() {
  const contentText = isPatientApp ? (
    <>
      Die Bereitstellung der App ist ohne diese Einwilligung nicht weiter
      möglich. Wenn Sie Ihre Einwilligung widerrufen, können Sie die App
      „neolexon Aphasie“ nicht länger verwenden und alle Ihre Daten werden mit
      sofortiger Wirkung unwiderruflich gelöscht. Falls Sie dies wünschen,
      können Sie vor der Löschung Ihre Daten
      <TextLink href={Links.export.href}>
        <Text style={styles.linkText}> hier </Text>
      </TextLink>
      unter Mein Account exportieren und abspeichern.
    </>
  ) : (
    <>
      Die Bereitstellung der App ist ohne diese Einwilligung nicht weiter
      möglich. Wenn Sie Ihre Einwilligung widerrufen, können Sie neolexon nicht
      länger verwenden und alle Ihre Daten werden mit sofortiger Wirkung
      unwiderruflich gelöscht.
    </>
  );

  return (
    <View style={styles.wrapper}>
      <Text style={styles.bodyText}>{contentText}</Text>
    </View>
  );
}

export default FirstConfirmAccountDelete;
